import { FC } from 'react';
import styled from 'styled-components';
import { IProps as IPasswordInputProps, PasswordInput } from '../PasswordInput/PasswordInput';
import { Theme } from '../theme';

const getStrengthColor = (width: number, theme: Theme) => {
  if (width === 0) {
    return 'transparent';
  } else if (width < 50) {
    return theme.vars.newColor.red2;
  } else if (width < 100) {
    return theme.vars.newColor.orange2;
  } else {
    return theme.vars.newColor.green2;
  }
};

const PasswordStrengthBar = styled.div<{ width: number; spacingBelow: boolean }>`
  background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
  height: 10px;
  position: relative;
  width: 100%;
  margin-bottom: ${({ spacingBelow }) => (spacingBelow ? '2rem' : 0)};
  margin-top: 0.5rem;

  &:before {
    transition: transform 0.5s ease;
    transform: ${({ width }) => `scaleX(${width / 100})`};
    transform-origin: 0;
    width: 100%;
    content: '';
    height: 10px;
    position: absolute;
    background-color: ${({ theme, width }) => getStrengthColor(width, theme)};
  }
`;

export interface IProps extends IPasswordInputProps {
  /** Password strength width prop */
  passwordStrengthWidth: number;
}

export const PasswordStrength: FC<IProps> = ({
  ariaLabel,
  label,
  required,
  disabled,
  placeholder,
  tabIndex,
  autoFocus,
  onChange,
  spacingBelow,
  hint,
  tooltipHeading,
  tooltipWidth,
  passwordStrengthWidth,
}) => {
  const handleChange = (value: string) => {
    onChange(value);
  };

  const width = passwordStrengthWidth <= 100 ? passwordStrengthWidth : 100;

  return (
    <div>
      <PasswordInput
        ariaLabel={ariaLabel}
        label={label}
        placeholder={placeholder}
        onChange={handleChange}
        disabled={disabled}
        tooltipHeading={tooltipHeading}
        tooltipWidth={tooltipWidth}
        required={required}
        tabIndex={tabIndex}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        hint={hint}
        spacingBelow={false}
      />
      <PasswordStrengthBar width={width} spacingBelow={spacingBelow} />
    </div>
  );
};
